// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__gH9L9","spinner":"loader_spinner__GQKuT"};